<div class="flt-ana-kutu">

  <div class="flt-toolbar">
    <div class="flt-toolbar-sol">
      <button nz-button nzSize="small" nzType="text" class="flt-toggle-btn"
              (click)="sablon.acik=!sablon.acik;CD.detectChanges();">
        <nz-icon [nzType]="sablon.acik ? 'caret-down' : 'caret-right'" />
      </button>
      <div class="flt-veva-grup">
        <button nz-button [nzType]="sablon.veVeya==='ve' ? 'primary' : 'default'" nzSize="small"
                (click)="sablon.veVeya='ve';CD.detectChanges();">Ve</button>
        <button nz-button [nzType]="sablon.veVeya==='veya' ? 'primary' : 'default'" nzSize="small"
                (click)="sablon.veVeya='veya';CD.detectChanges();">Veya</button>
      </div>
    </div>
    <div class="flt-toolbar-sag">
      <button nz-button nzSize="small" nzType="dashed" nz-tooltip nzTooltipTitle="Filtre alanı ekle"
              (click)="alanSecimModalAc(sablon);">
        <nz-icon nzType="plus" /><span class="flt-btn-yazi">Ekle</span>
      </button>
      <button nz-button nzSize="small" nzType="dashed" nz-tooltip nzTooltipTitle="Grup ekle"
              (click)="grupEkle(sablon);">
        <nz-icon nzType="block" />
      </button>
    </div>
  </div>
  <!--  -->
  <nz-empty nzNotFoundImage="simple"
            nzNotFoundContent="Sağ Üstteki Butonlardan Filitre Ekleyebilirsiniz."
            style="min-height: unset;margin-top: 0;border-radius:1em;margin-top: 5px;"
            *ngIf="sablon.acik==true && sablon.alanlar!.length<1">
  </nz-empty>
  <!--  -->
  <div *ngIf="sablon.acik==true  && sablon.alanlar!.length>0">
    <div *ngFor="let item of sablon.alanlar; index as i;last as l; trackBy: trackByIndex">
      <!-- <ng-container *ngIf="item.constructor.name=='IGrup'; then grupTemplate"></ng-container> -->

      <ng-container
                    *ngTemplateOutlet="item.veVeya ? grupTemplate : alanTemplate; context:{ item: item, ustitem:sablon, index:i, last:l, }">
      </ng-container>
    </div>
  </div>
  <div style="display: flex; gap: 6px; align-items: center; padding: 6px 8px 4px; border-top: 1px solid var(--py-kenarlik, #e8e8e8); flex-wrap: wrap;">
    @if (siralamalar.length > 0) {
      <div class="flt-siralama-dropdown" style="margin-right: auto;">
        <span class="flt-siralama-etiket">Sırala:</span>
        <nz-select class="flt-siralama-select" nzSize="small"
                   [ngModel]="siralama"
                   (ngModelChange)="siralamaSecildi($event)"
                   [compareWith]="siralamaKarsilastir"
                   nzPlaceHolder="Sıralama..." style="min-width: 150px">
          @for (s of siralamalar; track s.ismi) {
            <nz-option [nzValue]="s.degeri" [nzLabel]="s.ismi"></nz-option>
          }
        </nz-select>
      </div>
    }
    @if (sablon?.alanlar?.length > 0) {
      <button nz-button nzSize="small" (click)="temizleBasildi.emit(); sablonChange.emit(sablon);">Temizle</button>
      <button nz-button nzSize="small" nzType="primary" (click)="uygulaBasildi.emit(); enterBasildi.emit();">
        🔍 Uygula
      </button>
    }
  </div>
</div>

<!--  -->
<ng-template #grupTemplate
             let-item="item"
             let-ustitem="ustitem"
             let-last="last">

  <div style="display: flex;flex-direction: column;">

    <div style="display: flex;flex-direction:row;">
      <div class="solCizgi"
           style="width: 10px;border-right: 1px solid var(--py-kenarlik, #d9d9d9);"
           [style.height]="last ? '75px':'unset'"></div>

      <div style="width: 10px;display: flex;flex-direction: row;align-items: center;">

        <div style="border-bottom:1px solid var(--py-kenarlik, #d9d9d9);flex: 1;margin-top:5px;"></div>


      </div>

      <div
           style="display: flex;flex-direction: column;flex:1;margin-top:5px;border: 1px solid var(--py-kenarlik, #d9d9d9);padding: 3px;border-radius: 1em;">

        <div style="display: flex;flex-direction:row;">
          <!--  -->
          <span [innerHtml]="item.acik ? '▶️':'🔽'"
                (click)="item.acik=!item.acik;CD.detectChanges();"></span>
          <!--  -->
          <nz-button-group nzSize="small">
            <button nz-button
                    nzType="primary"
                    [nzDanger]="item.veVeya=='ve'"
                    nzSize="small"
                    (click)="item.veVeya='ve';CD.detectChanges();">
              Ve
            </button>
            <button nz-button
                    nzType="primary"
                    [nzDanger]="item.veVeya=='veya'"
                    nzSize="small"
                    (click)="item.veVeya='veya';CD.detectChanges();">
              Veya
            </button>
          </nz-button-group>
          <!--  -->


          <div style="flex:1"></div>

          <button nz-button
                  nzShape="circle"
                  nzSize="small"
                  (click)="alanSecimModalAc(item);">
            <span>➕</span>
          </button>
          <button nz-button
                  nzShape="circle"
                  nzSize="small"
                  (click)="grupEkle(item);">
            <span>🖇</span>
          </button>

          <button nz-button
                  nzShape="circle"
                  nzSize="small"
                  nzDanger
                  (click)="grupSil(ustitem,item);">
            <span>🗑️</span>
          </button>

        </div>
        <!--  -->
        <nz-empty nzNotFoundImage="simple"
                  nzNotFoundContent="Sağ Üstteki Butonlardan Filitre Ekleyebilirsiniz."
                  style="min-height: unset;margin-top: 0;border-radius:1em;margin-top: 5px;"
                  *ngIf="item.acik==true && item.alanlar!.length<1">
        </nz-empty>
        <!--  -->

        <div *ngIf="item.acik==true  && item.alanlar!.length>0">
          <div *ngFor="let altitem of item.alanlar; index as i;last as l; trackBy: trackByIndex">
            <ng-container
                          *ngTemplateOutlet="altitem.veVeya ? grupTemplate : alanTemplate; context:{ item: altitem, ustitem:item, index:i, last:l, }">
            </ng-container>
          </div>
        </div>

      </div>

    </div>

  </div>

</ng-template>


<!--  -->
<ng-template #alanTemplate
             let-item="item"
             let-ustitem="ustitem"
             let-index="index"
             let-last="last">

  <div style="display: flex;flex-direction: column;">

    <div style="display: flex;flex-direction:row;">
      <div class="solCizgi"
           style="width: 10px;border-right: 1px solid var(--py-kenarlik, #d9d9d9);"
           [style.height]="last ? '50px':'unset'">
      </div>

      <div style="width: 10px;display: flex;flex-direction: row;align-items: center;">

        <div style="border-bottom:1px solid var(--py-kenarlik, #d9d9d9);flex: 1;margin-top:5px;"></div>


      </div>

      <div
           style="display: flex;flex-direction: column;flex:1;margin-top:5px;border: 1px solid var(--py-kenarlik, #d9d9d9);padding: 3px;border-radius: 1em;">

        <div style="display: flex;flex-direction:row;flex:1;">

          <button nz-button
                  nzShape="circle"
                  nzDanger
                  nzSize="small"
                  (click)="grupSil(ustitem,item);"
                  style="position: absolute;margin-left:-10px;margin-top:-10px;z-index: 1;">
            <span>❌</span>
          </button>

        </div>

        <div style="display: flex;flex-direction: column;">

          <!-- Alan Şablonu (modal ile seçim) -->
          <nz-input-wrapper nzSuffixIcon="down"
                          nzSize="small"
                          style="margin:0.25em 1em;flex:1;width:unset;cursor:pointer;"
                          (click)="alanDegistirModalAc(ustitem, index)">
            <input type="text" nz-input [ngModel]="item.baslik" nzSize="small" readonly style="cursor:pointer" />
          </nz-input-wrapper>

          <!-- <div style="text-align: center;font-size: medium;font-weight: bold;" [innerHTML]="item.baslik"></div> -->

          <ng-container *ngIf="alanIcinSablonBul(item) as template; else defaultInput">
            <ng-container *ngTemplateOutlet="template; context: item"></ng-container>
          </ng-container>

          <!-- Eşitlikler -->

          <ng-template #esitlikler>
            <div style="display: flex;justify-content: center;flex-wrap: wrap;">
              <nz-button-group nzSize="small">
                <button nz-button
                        [nzType]="item.aktifEsitlikTuru==est ? 'primary':null"
                        nzSize="small"
                        *ngFor="let est of item.esitlikTurleri ?? varsayilanEsitlikTurleri; index as i; first as isFirst; trackBy: trackByIndex"
                        (click)="item.aktifEsitlikTuru=est;CD.detectChanges();"
                        [innerText]="est"></button>
              </nz-button-group>
            </div>

          </ng-template>

          <!-- Varsayılan Şablonlar  -->
          <ng-template #defaultInput>

            <div [ngSwitch]="item.tipi"
                 style="line-height: normal;flex:1;">

              <!-- Yazı Kutusu -->
              <div *ngSwitchCase="'Yazı Kutusu'"
                   style="display: flex;flex-direction: column;">
                <ng-container *ngTemplateOutlet="esitlikler; context: item"></ng-container>
                @if (item.aktifEsitlikTuru !== 'Olan' && item.aktifEsitlikTuru !== 'Olmayan' && item.aktifEsitlikTuru !== 'Boş Olan' && item.aktifEsitlikTuru !== 'Boş Olmayan') {
                <nz-input-wrapper [nzSuffix]="item.sagSimge"
                                [nzPrefix]="item.solSimge"
                                nzSize="small"
                                style="margin:0.25em 1em;width: unset;">
                  <input type="text" nz-input [placeholder]="item.yerTutucu" [(ngModel)]="item.degeri" nzSize="small" (keydown.enter)="enterBasildi.emit();"/>
                </nz-input-wrapper>
                }
                <span nz-typography
                      nzType="secondary">{{ item.aciklama }}</span>
              </div>
              <!-- Çoklu Yazı Kutusu -->
              <div *ngSwitchCase="'Çoklu Yazı Kutusu'"
                   style="display: flex;flex-direction: column;">
                <!-- <ng-container *ngTemplateOutlet="esitlikler; context: item"></ng-container> -->
                <nz-input-wrapper [nzSuffix]="item.sagSimge"
                                [nzPrefix]="item.solSimge"
                                nzSize="small"
                                style="margin:0.25em 1em;width: unset;">
                  <input type="text" nz-input [placeholder]="item.yerTutucu" [(ngModel)]="item.degeri" nzSize="small" (keydown.enter)="enterBasildi.emit();"/>
                </nz-input-wrapper>
                <span nz-typography
                      nzType="secondary">{{ item.aciklama }}</span>
              </div>
              <!-- Sayı Kutusu -->
              <div *ngSwitchCase="'Sayı Kutusu'"
                   style="display: flex;flex-direction: column;">
                <ng-container *ngTemplateOutlet="esitlikler; context: item"></ng-container>
                @if (item.aktifEsitlikTuru === 'aralık') {
                  <div style="display:flex;gap:6px;margin:0.25em 1em;">
                    <nz-input-wrapper nzSize="small" nzAddonBefore="≥" style="flex:1">
                      <input type="number" nz-input nzSize="small" placeholder="min" [(ngModel)]="item._aralikMin" (keydown.enter)="enterBasildi.emit();"/>
                    </nz-input-wrapper>
                    <nz-input-wrapper nzSize="small" nzAddonBefore="≤" style="flex:1">
                      <input type="number" nz-input nzSize="small" placeholder="max" [(ngModel)]="item._aralikMax" (keydown.enter)="enterBasildi.emit();"/>
                    </nz-input-wrapper>
                  </div>
                } @else if (item.aktifEsitlikTuru !== 'Olan' && item.aktifEsitlikTuru !== 'Olmayan' && item.aktifEsitlikTuru !== 'Boş Olan' && item.aktifEsitlikTuru !== 'Boş Olmayan') {
                <nz-input-wrapper [nzSuffix]="item.sagSimge"
                                [nzPrefix]="item.solSimge"
                                nzSize="small"
                                style="margin:0.25em 1em;width: unset;">
                  <input type="text" type="number" nz-input [placeholder]="item.yerTutucu" [(ngModel)]="item.degeri" nzSize="small" (keydown.enter)="enterBasildi.emit();"/>
                </nz-input-wrapper>
                }
                <span nz-typography
                      nzType="secondary">{{ item.aciklama }}</span>
              </div>
              <!-- Tarih Kutusu -->
              <div *ngSwitchCase="'Tarih Kutusu'"
                   style="display: flex;flex-direction: column;">
                <ng-container *ngTemplateOutlet="esitlikler; context: item"></ng-container>
                @if (item.aktifEsitlikTuru !== 'Olan' && item.aktifEsitlikTuru !== 'Olmayan' && item.aktifEsitlikTuru !== 'Boş Olan' && item.aktifEsitlikTuru !== 'Boş Olmayan') {
                <nz-date-picker [(ngModel)]="item.degeri"
                                nzSize="small"
                                [nzPlaceHolder]="item.yerTutucu ?? 'Tarih seçin'"
                                nzFormat="dd.MM.yyyy"
                                style="margin:0.25em 1em;width: unset;"
                                (ngModelChange)="CD.detectChanges();"
                                (keydown.enter)="enterBasildi.emit();">
                </nz-date-picker>
                }
                <span nz-typography
                      nzType="secondary">{{ item.aciklama }}</span>
              </div>
              <!-- Özel Açılır Kutu -->
              <div *ngSwitchCase="'Özel Açılır Kutu'"
                   style="display: flex;flex-direction: column;">
                <ng-container *ngTemplateOutlet="esitlikler; context: item"></ng-container>
                @if (item.aktifEsitlikTuru !== 'Olan' && item.aktifEsitlikTuru !== 'Olmayan' && item.aktifEsitlikTuru !== 'Boş Olan' && item.aktifEsitlikTuru !== 'Boş Olmayan') {
                <nz-input-wrapper [nzSuffix]="item.sagSimge"
                                [nzPrefix]="item.solSimge"
                                nzSize="small"
                                nz-dropdown
                                [nzDropdownMenu]="menu"
                                style="margin:0.25em 1em;flex:1;width:unset;"
                                nzTrigger="click">
                  <input type="text" nz-input [ngModel]="item?.degeri?.baslik" [placeholder]="item.yerTutucu" nzSize="small" readonly />
                </nz-input-wrapper>

                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li nz-menu-item
                        *ngFor="let alan of item?.ek?.liste; index as i; first as isFirst; trackBy: trackByIndex"
                        (click)="item.degeri=alan;CD.detectChanges();">
                      {{ alan.baslik }}
                    </li>
                  </ul>
                </nz-dropdown-menu>
                }
              </div>
              <!-- Eşitlik Kutusu -->
              <div *ngSwitchCase="'Kayar Seçim Kutusu'"
                   style="display: flex;justify-content: center;">

                <nz-segmented [(ngModel)]="item.degeri"
                              [nzOptions]="item?.ek?.liste"></nz-segmented>

                <!-- <nz-switch [ngModel]="item.degeri" [nzCheckedChildren]="item.ek.acikYazi"
                  [nzUnCheckedChildren]="item.ek.kapaliYazi"></nz-switch> -->


                <span nz-typography
                      nzType="secondary">{{ item.aciklama }}</span>
              </div>
              <!-- Bileşen Seçimi -->
              <div *ngSwitchCase="'Bileşen Seçimi'">
                <div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:6px;justify-content:center;">
                  <nz-button-group nzSize="small">
                    <button nz-button nzSize="small"
                            *ngFor="let est of item.esitlikTurleri; trackBy: trackByIndex"
                            [nzType]="item.aktifEsitlikTuru==est ? 'primary' : null"
                            (click)="item.aktifEsitlikTuru=est;CD.detectChanges();"
                            [innerText]="est"></button>
                  </nz-button-group>
                </div>
                <div class="flt-bilesen-secim">
                  @for (sec of item.bilesenSecenekleri || []; track sec.id) {
                    <button class="flt-bsec"
                            [class.flt-bsec--aktif]="bilesenSeciliMi(item, sec.id)"
                            [style.--flt-renk]="sec.renk || '#1890ff'"
                            (click)="bilesenToggle(item, sec.id)">
                      @if (sec.simge) { <span class="flt-bsec-simge">{{ sec.simge }}</span> }
                      <span>{{ sec.baslik }}</span>
                    </button>
                  }
                </div>
              </div>
              <!-- Üye Seçimi -->
              <div *ngSwitchCase="'Üye Seçimi'"
                   style="display: flex;flex-direction: column;">
                <ng-container *ngTemplateOutlet="esitlikler; context: item"></ng-container>
                @if (item.aktifEsitlikTuru !== 'Olan' && item.aktifEsitlikTuru !== 'Olmayan' && item.aktifEsitlikTuru !== 'Boş Olan' && item.aktifEsitlikTuru !== 'Boş Olmayan') {
                <div class="flt-uye-secim" style="margin:0.25em 1em;">
                  <nz-select nzShowSearch nzServerSearch nzAllowClear
                             [(ngModel)]="item.degeri"
                             (ngModelChange)="uyeSecildi($event)"
                             [nzPlaceHolder]="item.yerTutucu || 'Üye ara...'"
                             (nzOnSearch)="uyeAra($event)"
                             (nzOpenChange)="$event && uyeAra('')"
                             nzSize="default"
                             [nzDropdownMatchSelectWidth]="false"
                             nzDropdownClassName="flt-uye-dropdown-panel"
                             [nzCustomTemplate]="uyeSeciliTpl"
                             style="width: 100%">
                    @for (u of uyeAramaSonuclari(); track u._id) {
                      <nz-option [nzValue]="u._id" [nzLabel]="u.isim + ' ' + u.soyIsim" nzCustomContent>
                        <div class="flt-uye-option">
                          @if (uyeResimUrl(u.resimId!)) {
                            <img class="flt-uye-avatar" [src]="uyeResimUrl(u.resimId!)" />
                          } @else {
                            <span class="flt-uye-avatar-placeholder">👤</span>
                          }
                          <span class="flt-uye-bilgi">
                            <span class="flt-uye-ad">{{ u.isim }} {{ u.soyIsim }}</span>
                            @if (u.kullaniciAdi) { <span class="flt-uye-kullanici">{{'@'}}{{ u.kullaniciAdi }}</span> }
                          </span>
                        </div>
                      </nz-option>
                    }
                  </nz-select>
                </div>
                }
              </div>

              <!-- ═══ SERBEST ALAN (Wildcard Field Path) ═══ -->
              <div *ngSwitchCase="'Serbest Alan'" class="flt-serbest-alan">
                <div class="flt-serbest-satir">
                  <span class="flt-mini-etiket">Alan Yolu</span>
                  <nz-input-wrapper nzSize="small" nzPrefix="🔗" style="margin:0 1em;width:unset;">
                    <input nz-input [(ngModel)]="item.serbestAlanIsmi"
                           placeholder="ör: veri.icerikler.ek.malzeme"
                           nzSize="small"
                           [nzAutocomplete]="alanYoluOto"
                           (keydown.enter)="enterBasildi.emit();" />
                  </nz-input-wrapper>
                  <nz-autocomplete #alanYoluOto [nzBackfill]="true">
                    @for (onerim of alanYoluOnerileri(item.serbestAlanIsmi); track onerim) {
                      <nz-auto-option [nzValue]="onerim" [nzLabel]="onerim">
                        <span class="flt-onerim-yol">{{ onerim }}</span>
                      </nz-auto-option>
                    }
                  </nz-autocomplete>
                </div>
                <div class="flt-serbest-satir">
                  <span class="flt-mini-etiket">Veri Tipi</span>
                  <nz-segmented [ngModel]="item.serbestAlanTipiIdx ?? 0"
                                [nzOptions]="SERBEST_ALAN_TIPLERI"
                                (ngModelChange)="serbestAlanTipiDegisti(item, $event)"
                                nzSize="small"
                                style="margin:0 1em;">
                  </nz-segmented>
                </div>
                <ng-container *ngTemplateOutlet="esitlikler; context: item"></ng-container>
                @if (item.aktifEsitlikTuru !== 'Olan' && item.aktifEsitlikTuru !== 'Olmayan' && item.aktifEsitlikTuru !== 'Boş Olan' && item.aktifEsitlikTuru !== 'Boş Olmayan') {
                  @if (item.serbestAlanTipi === 'tarih') {
                    <nz-date-picker [(ngModel)]="item.degeri" nzSize="small"
                                    [nzPlaceHolder]="'Tarih seçin'" nzFormat="dd.MM.yyyy"
                                    style="margin:0.25em 1em;width:unset;"
                                    (ngModelChange)="CD.detectChanges();"
                                    (keydown.enter)="enterBasildi.emit();"></nz-date-picker>
                  } @else {
                    <nz-input-wrapper nzSize="small" style="margin:0.25em 1em;width:unset;">
                      <input nz-input [(ngModel)]="item.degeri"
                             [type]="item.serbestAlanTipi === 'sayı' ? 'number' : 'text'"
                             [placeholder]="'Değer girin...'"
                             nzSize="small"
                             (keydown.enter)="enterBasildi.emit();" />
                    </nz-input-wrapper>
                  }
                }
              </div>

              <!-- ═══ DİNAMİK BİLEŞEN FİLTRESİ ═══ -->
              <div *ngSwitchCase="'Dinamik Bileşen Filtresi'" class="flt-dinamik-bilesen">
                <div class="flt-serbest-satir">
                  <span class="flt-mini-etiket">Bileşen</span>
                  <nz-select [(ngModel)]="item.dinamikBilesenId"
                             nzSize="small" nzShowSearch nzAllowClear
                             nzPlaceHolder="Bileşen seçin..."
                             (ngModelChange)="dinamikBilesenDegisti(item, $event)"
                             style="width:calc(100% - 2em);margin:0 1em;">
                    @for (db of dinamikBilesenSetleri; track db.id) {
                      <nz-option [nzValue]="db.id" [nzLabel]="(db.simge || '📦') + ' ' + db.baslik" nzCustomContent>
                        <span>{{ db.simge || '📦' }}</span>
                        <span style="margin-left:6px;">{{ db.baslik }}</span>
                      </nz-option>
                    }
                  </nz-select>
                </div>
                @if (item.dinamikBilesenId) {
                  <div class="flt-serbest-satir">
                    <span class="flt-mini-etiket">Alan</span>
                    <nz-select [(ngModel)]="item.dinamikBilesenAlanIsmi"
                               nzSize="small" nzShowSearch nzAllowClear
                               nzPlaceHolder="Alan seçin..."
                               (ngModelChange)="dinamikBilesenAlanDegisti(item, $event)"
                               style="width:calc(100% - 2em);margin:0 1em;">
                      @for (p of dinamikBilesenParametreleriAl(item.dinamikBilesenId); track p.ismi) {
                        <nz-option [nzValue]="p.ismi" [nzLabel]="(p.baslik || p.ismi)" nzCustomContent>
                          <span class="flt-db-param-tip">{{ p.turu }}</span>
                          <span>{{ p.baslik || p.ismi }}</span>
                        </nz-option>
                      }
                    </nz-select>
                  </div>
                }
                @if (item.dinamikBilesenAlanIsmi) {
                  @if (item._ozelTip === 'olcu-sinir') {
                    <!-- Pozisyonel min/max sınır input (sıralı küçük→büyük) -->
                    <ng-container *ngTemplateOutlet="esitlikler; context: item"></ng-container>
                    @if (item.aktifEsitlikTuru !== 'Olmayan' && item.aktifEsitlikTuru !== 'Boş Olan') {
                      <div style="margin:0.25em 1em;display:flex;flex-direction:column;gap:4px;">
                        @for (sat of item._olcuSatirlari; track $index) {
                          <div style="display:flex;align-items:center;gap:6px;">
                            <span style="font-size:11px;color:var(--py-metin-ucuncul,#999);min-width:100px;">{{ sat.etiket }}</span>
                            <nz-input-wrapper nzSize="small" nzAddonBefore="≥" style="flex:1">
                              <input nz-input type="number" nzSize="small"
                                     [(ngModel)]="sat.min" placeholder="min"
                                     (keydown.enter)="enterBasildi.emit();" />
                            </nz-input-wrapper>
                            <nz-input-wrapper nzSize="small" nzAddonBefore="≤" style="flex:1">
                              <input nz-input type="number" nzSize="small"
                                     [(ngModel)]="sat.max" placeholder="max"
                                     (keydown.enter)="enterBasildi.emit();" />
                            </nz-input-wrapper>
                          </div>
                        }
                      </div>
                    }
                  } @else {
                    <ng-container *ngTemplateOutlet="esitlikler; context: item"></ng-container>
                  }
                  @if (item._ozelTip !== 'olcu-sinir' && item.aktifEsitlikTuru !== 'Olan' && item.aktifEsitlikTuru !== 'Olmayan' && item.aktifEsitlikTuru !== 'Boş Olan' && item.aktifEsitlikTuru !== 'Boş Olmayan') {
                    @if (item._ozelTip === 'olcu-uclu') {
                      <div style="margin:0.25em 1em;display:flex;flex-direction:column;gap:4px;">
                        <details style="font-size:11px;background:var(--py-arkaplan-soluk,rgba(0,0,0,.03));border:1px solid var(--py-kenarlik,#e5e7eb);border-radius:6px;padding:4px 8px;">
                          <summary style="cursor:pointer;color:var(--py-link,#1890ff);user-select:none;">📖 Format örnekleri</summary>
                          <div style="margin-top:6px;font-family:monospace;font-size:10.5px;line-height:1.7;color:var(--py-metin-ikincil,#666);">
                            <div><b>Tek ölçü:</b></div>
                            <div>• <code>2500</code> — bir eksende tam 2500 olan</div>
                            <div>• <code>&gt;4000</code> — bir ekseni 4000'den büyük</div>
                            <div>• <code>&gt;=200,&lt;=300</code> — bir ekseni 200-300 arası</div>
                            <div>• <code>200-300</code> — kısa aralık formu</div>
                            <div style="margin-top:4px;"><b>İki/üç ölçü (× ile):</b></div>
                            <div>• <code>2500x250</code> — 2 farklı eksende 2500 ve 250</div>
                            <div>• <code>2500x250x4685</code> — sırasız tam eşleşme</div>
                            <div>• <code>&gt;2400,&lt;2600x250x&gt;4684</code> — her eksene ayrı koşul</div>
                            <div>• <code>&gt;=200x&gt;=1000x&gt;=4000</code> — "bu parçayı kesebilen" min koşullar</div>
                            <div>• <code>&lt;400x&lt;3000x&lt;5000</code> — maksimum ölçü</div>
                            <div>• <code>2500x*x&gt;4000</code> — orta eksen serbest (* wildcard)</div>
                            <div>• <code>!=2500</code> — eşit değil</div>
                            <div style="margin-top:4px;color:var(--py-metin-ucuncul,#999);"><b>Operatörler:</b> = != &gt; &gt;= &lt; &lt;=</div>
                          </div>
                        </details>
                        <nz-input-wrapper nzSize="small">
                          <input nz-input [(ngModel)]="item.degeri"
                                 type="text"
                                 placeholder="Örn: 2500x250x4685 veya >2400,<2600x250x>4684"
                                 nzSize="small"
                                 (keydown.enter)="enterBasildi.emit();" />
                        </nz-input-wrapper>
                      </div>
                    } @else if (item._acilirSecenekler?.length) {
                      <nz-select [(ngModel)]="item.degeri" nzSize="small" nzAllowClear
                                 [nzMode]="item._dbCoklu ? 'multiple' : 'default'"
                                 nzPlaceHolder="Değer seçin..."
                                 style="width:calc(100% - 2em);margin:0.25em 1em;">
                        @for (sec of item._acilirSecenekler; track sec.deger) {
                          <nz-option [nzValue]="sec.deger" [nzLabel]="sec.etiket"></nz-option>
                        }
                      </nz-select>
                    } @else if (item.serbestAlanTipi === 'tarih') {
                      <nz-date-picker [(ngModel)]="item.degeri" nzSize="small"
                                      [nzPlaceHolder]="'Tarih seçin'" nzFormat="dd.MM.yyyy"
                                      style="margin:0.25em 1em;width:unset;"
                                      (ngModelChange)="CD.detectChanges();"
                                      (keydown.enter)="enterBasildi.emit();"></nz-date-picker>
                    } @else if (item.serbestAlanTipi === 'sayı' && item.aktifEsitlikTuru === 'aralık') {
                      <div style="display:flex;gap:6px;margin:0.25em 1em;">
                        <nz-input-wrapper nzSize="small" nzAddonBefore="≥" style="flex:1">
                          <input type="number" nz-input nzSize="small" placeholder="min" [(ngModel)]="item._aralikMin" (keydown.enter)="enterBasildi.emit();"/>
                        </nz-input-wrapper>
                        <nz-input-wrapper nzSize="small" nzAddonBefore="≤" style="flex:1">
                          <input type="number" nz-input nzSize="small" placeholder="max" [(ngModel)]="item._aralikMax" (keydown.enter)="enterBasildi.emit();"/>
                        </nz-input-wrapper>
                      </div>
                    } @else {
                      <nz-input-wrapper nzSize="small" style="margin:0.25em 1em;width:unset;">
                        <input nz-input [(ngModel)]="item.degeri"
                               [type]="item.serbestAlanTipi === 'sayı' ? 'number' : 'text'"
                               [placeholder]="'Değer girin...'"
                               nzSize="small"
                               (keydown.enter)="enterBasildi.emit();" />
                      </nz-input-wrapper>
                    }
                  }
                }
              </div>

            </div>


          </ng-template>


        </div>

      </div>

    </div>

  </div>

</ng-template>


<!-- <div>
  {{ toSql() }}
</div> -->

<ng-template #uyeSeciliTpl let-selected>
  <div class="flt-uye-secili">
    @if (uyeSeciliBilgi(selected.nzValue); as bilgi) {
      @if (uyeResimUrl(bilgi.resimId!)) {
        <img class="flt-uye-avatar-sm" [src]="uyeResimUrl(bilgi.resimId!)" />
      } @else {
        <span class="flt-uye-avatar-placeholder-sm">👤</span>
      }
    } @else {
      <span class="flt-uye-avatar-placeholder-sm">👤</span>
    }
    <span class="flt-uye-secili-ad">{{ selected.nzLabel }}</span>
  </div>
</ng-template>

<nz-modal [(nzVisible)]="alanSecimModalAcik"
          nzTitle="Filtre Alan\u0131 Ekle"
          [nzWidth]="520"
          nzCentered
          [nzFooter]="null"
          (nzOnCancel)="alanSecimModalAcik=false;CD.detectChanges();">
  <ng-container *nzModalContent>
    <div class="alan-secim-arama">
      <nz-input-wrapper nzPrefix="🔍" nzSize="default">
        <input nz-input [(ngModel)]="alanSecimArama" placeholder="Alan ara..." />
      </nz-input-wrapper>
    </div>
    <div class="alan-secim-liste">
      <ng-container *ngFor="let kat of filtrelenmisKategoriler; trackBy: trackByIndex">
        <div class="alan-kat">
          <div class="alan-kat-baslik">
            <span>{{ kat.emoji || '📋' }}</span>
            {{ kat.kategori }}
          </div>
          <div class="alan-kat-grid">
            <button *ngFor="let item of kat.alanlar; trackBy: trackByIndex"
                    class="alan-kat-item"
                    (click)="alanSecildi(item)">
              <span class="alan-kat-ikon">{{ item.alan.solSimge || '🔹' }}</span>
              <div class="alan-kat-bilgi">
                <span class="alan-kat-ad">{{ item.alan.baslik }}</span>
                <span class="alan-kat-aciklama" *ngIf="item.aciklama">{{ item.aciklama }}</span>
              </div>
            </button>
          </div>
        </div>
      </ng-container>
      <div class="alan-bos" *ngIf="filtrelenmisKategoriler.length === 0">
        Sonu\u00E7 bulunamad\u0131
      </div>
    </div>
  </ng-container>
</nz-modal>